import {
  breakpointSizes,
  Button,
  ButtonDesigns,
  ButtonTypes,
  getBreakpointDown,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import AppName from 'src/components/AppName/AppName'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import SvgChevronLeft from 'src/components/Svgs/SvgChevronLeft'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface ConfirmDisconnectOrgIntegrationViewProps {
  disconnectIntegration: () => void
  goBack: () => void
  loading?: boolean
  connectedPlatformName: string
}

const ConfirmDisconnectOrgIntegrationView: React.FC<
  ConfirmDisconnectOrgIntegrationViewProps
> = (props): React.ReactElement => {
  const translate = useTranslate()

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        padding: 50px 60px;

        ${getBreakpointDown(breakpointSizes.XSM)(css`
          padding: 40px;
        `)};

        ${getBreakpointDown(breakpointSizes.XXSM)(css`
          padding: 40px 20px;
        `)};
      `}
    >
      <span
        css={css`
          ${getFontCss(
            20,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
          padding-bottom: 12px;
        `}
      >
        {translate('Disconnect Org')}
      </span>

      <p
        css={css`
          margin-bottom: 40px;
        `}
      >
        {translate(
          'Disconnecting all ${appName} accounts from ${connectedPlatform} will end data sharing between ${appName} and ${connectedPlatform}.',
          {
            appName: <AppName />,
            connectedPlatform: props.connectedPlatformName,
          },
        )}
      </p>

      <div
        css={css`
          display: flex;
          align-items: center;
          justify-content: space-between;
        `}
      >
        <HoverableLink
          css={css`
            display: flex;
            align-items: center;
          `}
          ariaLabelSource={'Back'}
          onClick={props.goBack}
        >
          <SvgChevronLeft />
          {translate('Back')}
        </HoverableLink>

        <Button
          onClick={props.disconnectIntegration}
          type={ButtonTypes.button}
          design={ButtonDesigns.designRed}
          text={translate('Confirm Disconnect')}
          loading={props.loading}
          big
        />
      </div>
    </div>
  )
}

export default ConfirmDisconnectOrgIntegrationView
